import React from 'react';
import PropTypes from 'prop-types';
import { decode } from 'html-decoder';
import defaultImage from 'large/destin-florida-communities.jpg';

export default function CommunityCard({ community, area }) {
  const communityImage =
    community.medium_featured_image_url ||
    community.small_featured_image_url ||
    community.featured_image_url ||
    defaultImage;

  const splitUrl = community.url.split('/');
  const slug = splitUrl[splitUrl.length - 2];

  const communityImageSplit = communityImage.split('.');
  const endFormat = communityImageSplit[communityImageSplit.length - 1];
  let imageFormatType = 'jpeg';
  if (endFormat === 'png') imageFormatType = 'png';
  if (endFormat === 'svg') imageFormatType = 'svg+xml';

  return (
    <a
      href={`/${area}/vacation-rentals/${slug}`}
      className="community-card"
      aria-label={`View community ${community.name}`}
    >
      <h3>{decode(community.name)}</h3>
      <p>{community.rentals} Rentals</p>
      <picture className="background-picture">
        <source
          data-srcset={`${community.featured_image_url} 1280w, ${community.medium_featured_image_url} 720w, ${community.small_featured_image_url} 400w`}
          sizes="200px"
          type={`image/${imageFormatType}`}
        />
        <img
          className="lazyload"
          data-src={communityImage}
          alt={`${decode(community.name)}`}
          title={`${decode(community.name)}`}
        />
      </picture>
      <div className="image-overlay" />
    </a>
  );
}

CommunityCard.propTypes = {
  community: PropTypes.object.isRequired,
  area: PropTypes.string.isRequired,
};
